"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tree = require("./tree");
// i18next-extract-mark-ns-start Trees

var getTreeAlterationSuitPackage = function getTreeAlterationSuitPackage(t) {
  var pricingVersion = (0, _tree.getPricingVersion)();
  return {
    question: {
      alteration: t('À quels endroits seront les retouches ?'),
      repair: t('À quels endroits seront les réparations ?')
    },
    pieces: {
      mant: {
        name: t('Veste de costume'),
        label: t('La veste'),
        question: t('Indiquez-nous le problème sur la veste :'),
        problems: {
          damaged: {
            label: t('Elle est abîmée'),
            question: t('À quel endroit est-elle abîmée ?'),
            answers: [{
              slug: 'entireLining',
              label: t('Sur toute la doublure'),
              id: "".concat(pricingVersion, ".mant-rep-div-3")
            }, {
              slug: 'liningPart',
              label: t('Sur une partie de la doublure'),
              id: "".concat(pricingVersion, ".mant-rep-div-2")
            }, {
              slug: 'pocket',
              label: t('Une poche est trouée'),
              id: "".concat(pricingVersion, ".mant-rep-tear-1"),
              isMultiple: true
            }, {
              slug: 'button',
              label: t('Il manque un bouton'),
              id: "".concat(pricingVersion, ".mant-rep-but-2"),
              isMultiple: true
            }, {
              slug: 'brokenZip',
              label: t('Le zip est bloqué'),
              id: "".concat(pricingVersion, ".mant-rep-zip-3"),
              isMultiple: true
            }, {
              slug: 'tornHoley',
              label: t('Elle est déchirée / trouée'),
              id: "".concat(pricingVersion, ".mant-rep-tear-1"),
              isMultiple: true
            }, {
              slug: 'reinforcement',
              label: t('Elle nécessite un renfort'),
              id: "".concat(pricingVersion, ".mant-rep-tear-2"),
              isMultiple: true
            }]
          }
        }
      },
      pant: {
        name: t('Pantalon de costume'),
        label: t('Le pantalon'),
        question: t('Indiquez-nous le problème sur le pantalon :'),
        problems: {
          hem: {
            label: t('Faire un ourlet'),
            question: t('À quel endroit est-il trop grand ?'),
            answers: [{
              slug: 'hem',
              label: t('Sur la longueur'),
              id: "".concat(pricingVersion, ".pant-ret-rac-5"),
              isNotSuit: true
            }]
          },
          damaged: {
            label: t('Il est abîmé'),
            question: t('À quel endroit est-ce abîmé ?'),
            answers: [{
              slug: 'pocket',
              label: t('Une poche est trouée'),
              id: "".concat(pricingVersion, ".pant-rep-tear-1"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'button',
              label: t('Il manque un bouton'),
              id: "".concat(pricingVersion, ".pant-rep-but-2"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'brokenZip',
              label: t('Le zip est bloqué'),
              id: "".concat(pricingVersion, ".pant-rep-zip-1"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'tornHoley',
              label: t('Il est déchiré / troué'),
              id: "".concat(pricingVersion, ".pant-rep-tear-1"),
              isMultiple: true,
              isNotSuit: true
            }, {
              slug: 'unraveledHem2',
              label: t('L‘ourlet est décousu (x2 jambes)'),
              id: "".concat(pricingVersion, ".pant-rep-div-7"),
              isNotSuit: true
            }]
          }
        }
      }
    }
  };
};
var _default = exports["default"] = getTreeAlterationSuitPackage;